import React, { useEffect, useState } from 'react';
import {
  Switch,
  Route,
  withRouter,
} from 'react-router-dom';
import { Menu } from 'antd';
import { SpTab } from 'components/DesignKit';

import Links from '../PaymentsLink/components/PaymentsLinkList';
import Buttons from '../Buttons';
import PagesList from '../PagesList';
import Widgets from '../PaymentWidgets/PaymentWidgetsList';
import Slug from '../AccountSlug/AccountSlugList';
import Reminders from '../Settings/components/Reminders';

type Props = {
  location: {
    pathname: string
  },
};

const PayLinks = (props: Props) => {
  const {
    location,
  } = props;
  const [current, setCurrent] = useState('links');

  const setMenu = (query) => {
    switch (query) {
      case '/pay-links': {
        setCurrent('links');
        break;
      }
      case '/pay-links/payment-buttons': {
        setCurrent('buttons');
        break;
      }
      case '/pay-links/payment-pages': {
        setCurrent('pages');
        break;
      }
      case '/pay-links/payment-widgets': {
        setCurrent('widgets');
        break;
      }
      case '/pay-links/subscription-button': {
        setCurrent('buttons');
        break;
      }
      case '/pay-links/events': {
        setCurrent('pages');
        break;
      }
      case '/pay-links/checkout-page': {
        setCurrent('pages');
        break;
      }
      case '/pay-links/donation-pages': {
        setCurrent('pages');
        break;
      }
      case '/pay-links/event-page/non-seated': {
        setCurrent('pages');
        break;
      }
      case '/pay-links/event-page/seated': {
        setCurrent('pages');
        break;
      }
      case '/pay-links/accountslug': {
        setCurrent('slug');
        break;
      }
      case '/pay-links/reminders': {
        setCurrent('reminders');
        break;
      }
      default:
        setCurrent('links');
    }
  };

  useEffect(() => {
    setMenu(location.pathname);
  }, [location]);

  return (
    <div>
      <Menu onClick={e => setCurrent(e.key)} selectedKeys={[current]} mode="horizontal" style={{ fontSize: '20px' }}>
        <Menu.Item key="links">
          <SpTab
            to="/pay-links"
            selected={current === 'links'}
          >
            Links
          </SpTab>
        </Menu.Item>
        <Menu.Item key="buttons">
          <SpTab
            to="/pay-links/payment-buttons"
            selected={current === 'buttons'}
          >
            Buttons
          </SpTab>
        </Menu.Item>
        <Menu.Item key="pages">
          <SpTab
            to="/pay-links/payment-pages"
            selected={current === 'pages'}
          >
            Pages
          </SpTab>
        </Menu.Item>
        <Menu.Item key="widgets">
          <SpTab
            to="/pay-links/payment-widgets"
            selected={current === 'widgets'}
          >
            Widgets
          </SpTab>
        </Menu.Item>
        <Menu.Item key="slug">
          <SpTab
            to="/pay-links/accountslug"
            selected={current === 'slug'}
          >
            Account Slug
          </SpTab>
        </Menu.Item>
        <Menu.Item key="reminders">
          <SpTab
            to="/pay-links/reminders"
            selected={current === 'reminders'}
          >
            Reminders
          </SpTab>
        </Menu.Item>
      </Menu>
      <Switch>
        <Route exact path="/pay-links" component={Links} />
        <Route exact path="/pay-links/payment-buttons" component={Buttons} />
        <Route exact path="/pay-links/payment-pages" component={PagesList} />
        <Route exact path="/pay-links/payment-widgets" component={Widgets} />
        <Route exact path="/pay-links/subscription-button" component={Buttons} />
        <Route exact path="/pay-links/events" component={PagesList} />
        <Route exact path="/pay-links/checkout-page" component={PagesList} />
        <Route exact path="/pay-links/donation-pages" component={PagesList} />
        <Route exact path="/pay-links/accountslug" component={Slug} />
        <Route exact path="/pay-links/reminders" component={Reminders} />
        <Route exact path="/pay-links/event-page/non-seated" component={PagesList} />
        <Route exact path="/pay-links/event-page/seated" component={PagesList} />
      </Switch>
    </div>
  );
};

export default withRouter(PayLinks);
